import { useLingui } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { Item } from './Item';

export const ArticleOrderNumber = () => {
  const { t } = useLingui();
  const { article } = useArticleContext();

  return (
    <Item
      label={t({ id: 'article.information.order-number', message: 'Order number' })}
      value={article.orderNumber}
    />
  );
};
